/**
 * collegeChallengeAccess.js
 *
 * Single source of truth for reading the College Challenge eligibility flag
 * that was cached in localStorage at login time.
 *
 * Usage:
 *   import { isCollegeChallengeEnabled } from '../utils/collegeChallengeAccess';
 *   const enabled = isCollegeChallengeEnabled();
 */

/**
 * Returns true if the currently logged-in college is among the first 100
 * and therefore eligible for the College Challenge feature.
 *
 * Falls back to false when the key is absent (e.g. not yet logged in,
 * or logged in before this feature was deployed).
 */
export function isCollegeChallengeEnabled() {
  return localStorage.getItem('collegeChallengeEnabled') === 'true';
}
